interface PatternObject {
  pattern: string;
  error: string;
}

export type ParsedValidationResult =
  | { type: 'patterns'; patterns: PatternObject[] }
  | { type: 'maxLength'; maxLength: string }
  | { type: 'unknown'; original: any }
  | null;

function isPatternArray(obj: unknown): obj is { patterns: PatternObject[] } {
  if (typeof obj === 'object' && obj !== null && 'patterns' in obj) {
    const raw = obj as { patterns: unknown };
    const { patterns } = raw;

    if (
      Array.isArray(patterns) &&
      patterns.every(
        (p): p is PatternObject =>
          typeof p === 'object' &&
          p !== null &&
          'pattern' in p &&
          typeof (p as Record<string, unknown>).pattern === 'string' &&
          'error' in p &&
          typeof (p as Record<string, unknown>).error === 'string'
      )
    ) {
      return true;
    }
  }

  return false;
}

function isMaxLengthObj(obj: unknown): obj is { maxLength: string } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'maxLength' in obj &&
    typeof (obj as { maxLength: unknown }).maxLength === 'string'
  );
}

/**
 * Utilty function to extract the validation error
 */
function extractValidationPattern(jsonStr: string): ParsedValidationResult {
  try {
    const parsed: unknown = JSON.parse(jsonStr);

    if (isPatternArray(parsed)) {
      return {
        type: 'patterns',
        patterns: parsed.patterns,
      };
    }

    if (isMaxLengthObj(parsed)) {
      return {
        type: 'maxLength',
        maxLength: parsed.maxLength,
      };
    }

    return { type: 'unknown', original: parsed };
  } catch (e) {
    return { type: 'unknown', original: jsonStr };
  }
}

export default extractValidationPattern;
